export const WAITING_UNDO = Symbol('waiting-undo-presentation');
